import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ENV_TOKEN, EnvConfig } from '@clean-code/models/common';
import {
  FlagResolver,
  SidenavControlsComponent,
} from '@clean-code/shared/components/ui-sidenav-controls';
import { SideNavService } from '@clean-code/shared/templates/ui-tailwind-full-width';
import { TranslocoModule } from '@jsverse/transloco';
import { animateFade, animateSlide } from '../animations/animations';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { UserMenuComponent } from '../user-menu/user-menu.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  imports: [
    CommonModule,
    RouterModule,
    TranslocoModule,
    SidebarComponent,
    UserMenuComponent,
    SidenavControlsComponent,
  ],
  animations: [animateFade, animateSlide],
})
export class SideNavComponent {
  public readonly env = inject<EnvConfig>(ENV_TOKEN);
  public readonly service = inject(SideNavService);

  public year: number = new Date().getFullYear();

  public readonly boFlagFor: FlagResolver = (langId) => {
    const id = langId || 'de';
    const code = id === 'de' ? 'DE_AU' : id.toUpperCase();
    return `./assets/img/Flag_${code}.svg`;
  };
}
